var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg581Brandmelder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451.667,
    height: 451.667,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 39.545,
    height: 39.545,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    ry: 213.823,
    rx: 213.741,
    id: "svg_5",
    cy: 226.958,
    cx: 223.877,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_17"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    id: "svg_1",
    d: "m291.878667,145.936545c9.199432,0 16.685789,-7.563433 16.685789,-16.857578s-7.486357,-16.857578 -16.685789,-16.857578s-16.685789,7.563433 -16.685789,16.857578s7.486357,16.857578 16.685789,16.857578zm0,-22.47677c3.064623,0 5.56193,2.517398 5.56193,5.619193s-2.497306,5.619193 -5.56193,5.619193s-5.56193,-2.517398 -5.56193,-5.619193s2.497306,-5.619193 5.56193,-5.619193z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "matrix(5.226504316270703,-1.9218770382021069,1.9022920003863655,5.280313765428618,-739.9358562462331,-316.87681217147974)",
    id: "svg_2",
    height: 9.472,
    width: 7.853,
    y: 136.741,
    x: 111.65,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "matrix(5.226504316270703,-1.9218770382021069,1.9022920003863655,5.280313765428618,-717.5085391789407,-335.7808765876827)",
    id: "svg_3",
    height: 16.404,
    width: 7.853,
    y: 120.159,
    x: 104.127,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "matrix(5.226504316270703,1.9218770382021069,-1.9022920003863655,5.280313765428618,-231.20112695062107,-830.38614332351)",
    id: "svg_4",
    height: 16.404,
    width: 7.853,
    y: 117.212,
    x: 152.941,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_6",
    height: 13.607,
    width: 43.676,
    y: 224.529,
    x: 125.546,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_7",
    height: 31.763,
    width: 331.034,
    y: 62.273,
    x: 53.363,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_8",
    height: 53.224,
    width: 43.676,
    y: 185.634,
    x: 222.38,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_9",
    height: 18.684,
    width: 192.795,
    y: 242.106,
    x: 123.176,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f03"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    transform: "matrix(-5.156931437661973,-2.104986575482562,2.0835355456492373,-5.210024599594675,659.2074346922586,1200.7306397248406)",
    id: "svg_10",
    height: 10.045,
    width: 3.408,
    y: 131.288,
    x: 129.858,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#193351",
    id: "svg_11",
    d: "m47.15376,56.029464l0,37.3002c0,2.028529 0.355964,4.028961 1.062329,5.922629l29.956553,80.702843c2.386068,6.422737 8.493067,10.755135 15.261935,10.906853l20.462339,51.679714l0,4.540308c0,12.395939 9.978102,22.47677 22.247719,22.47677l166.857892,0c12.269617,0 22.247719,-10.080831 22.247719,-22.47677l0,-4.540308l20.462339,-51.685333c6.768868,-0.151718 12.870305,-4.484116 15.261935,-10.906853l29.956553,-80.702843c0.706365,-1.893668 1.062329,-3.888481 1.062329,-5.91701l0,-37.3002l-344.839643,0zm333.715783,11.238385l0,22.47677l-322.591924,0l0,-22.47677l322.591924,0zm-116.800524,33.715155l55.619297,0l0,28.095963c0,15.492114 -12.475408,28.095963 -27.809649,28.095963s-27.809649,-12.603849 -27.809649,-28.095963l0,-28.095963zm-158.642921,89.907081l43.638901,0l17.798175,44.95354l-43.638901,0l-17.798175,-44.95354zm119.709413,44.95354l0,-44.95354l52.966257,0l-17.798175,44.95354l-35.168082,0zm-11.123859,0l-35.168082,0l-17.798175,-44.95354l52.966257,0l0,44.95354zm88.990876,22.47677l-166.857892,0c-6.134808,0 -11.123859,-5.040416 -11.123859,-11.238385l189.105611,0c0,6.197969 -4.989051,11.238385 -11.123859,11.238385zm12.920363,-22.47677l-43.638901,0l17.798175,-44.95354l43.638901,0l-17.798175,44.95354zm34.634136,-59.838781c-0.812042,2.180247 -2.903327,3.646856 -5.205966,3.646856l-251.554957,0c-2.308201,0 -4.399486,-1.466609 -5.211528,-3.646856l-27.84302,-75.02184l192.203605,0l0,28.095963c0,21.684464 17.464459,39.334348 38.933508,39.334348s38.933508,-17.649884 38.933508,-39.334348l0,-28.095963l47.593433,0l-27.848582,75.02184z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f03",
    id: "svg_12",
    d: "m219.573581,393.181017c-42.59882,0 -82.6614,-17.352067 -112.801497,-48.858879l-7.998055,7.816297c32.259192,33.709536 75.158356,52.280967 120.799552,52.280967s88.540359,-18.571431 120.799552,-52.286587l-7.998055,-7.816297c-30.140097,31.512432 -70.202677,48.864498 -112.801497,48.864498z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f03",
    id: "svg_13",
    d: "m121.099615,329.734714c27.147779,27.269941 62.810872,40.896483 98.473966,40.896483s71.326187,-13.632161 98.473966,-40.896483l-7.842321,-7.968015c-49.973939,50.190628 -131.283789,50.190628 -181.26329,0l-7.842321,7.968015z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f03",
    id: "svg_14",
    d: "m295.666342,307.387185l-7.569786,-8.232117c-37.782189,35.440247 -99.258198,35.440247 -137.040386,0l-7.569786,8.232117c20.979599,19.684031 48.533399,29.523238 76.092761,29.523238s55.1076,-9.839206 76.087199,-29.523238z"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_15",
    height: 78.757,
    width: 247.318,
    y: 100.921,
    x: 96.46,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg581Brandmelder);
export default __webpack_public_path__ + "static/media/581 Brandmelder.d98ef745fd9738981f81c7aea323ad5b.svg";
export { ForwardRef as ReactComponent };